import { c as _c } from "react/compiler-runtime";
import type { CalendarDay } from "@/helpers/calendar/calendar.helpers";
import { Time } from "@/helpers/time";
enum CalendarDaySate {
  NOT_ACTIVE_MONTH = "NOT_ACTIVE_MONTH",
  MANUALLY_DISABLED = "MANUALLY_DISABLED",
  AVAILABLE = "AVAILABLE",
  ACTIVE = "ACTIVE",
}
export default function CommonCalendarDay(t0) {
  const $ = _c(18);
  const {
    day,
    selectedTimestamp,
    minTimestamp,
    maxTimestamp,
    setSelectedTimestamp
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [CalendarDaySate.NOT_ACTIVE_MONTH]: "tw-bg-transparent tw-text-iron-400",
      [CalendarDaySate.MANUALLY_DISABLED]: "tw-bg-iron-600 tw-text-iron-400",
      [CalendarDaySate.AVAILABLE]: "tw-font-normal tw-bg-iron-700 tw-text-white hover:tw-bg-iron-700 hover:tw-border-primary-400 hover:tw-shadow-md",
      [CalendarDaySate.ACTIVE]: "tw-bg-primary-500 tw-text-white tw-font-semibold tw-shadow-lg tw-shadow-primary-500/20 tw-ring-2 tw-ring-primary-400/50"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const BUTTON_CLASSES = t1;
  let t2;
  if ($[1] !== day.isActiveMonth || $[2] !== day.startTimestamp || $[3] !== maxTimestamp || $[4] !== minTimestamp || $[5] !== selectedTimestamp) {
    const getDayState = () => {
      if (!day.isActiveMonth) {
        return CalendarDaySate.NOT_ACTIVE_MONTH;
      }
      if (minTimestamp && day.startTimestamp < minTimestamp && !(day.startTimestamp <= minTimestamp && day.startTimestamp + Time.days(1).toMillis() > minTimestamp)) {
        return CalendarDaySate.MANUALLY_DISABLED;
      }
      if (maxTimestamp && day.startTimestamp > maxTimestamp) {
        return CalendarDaySate.MANUALLY_DISABLED;
      }
      if (selectedTimestamp && day.startTimestamp <= selectedTimestamp && day.startTimestamp + Time.days(1).toMillis() > selectedTimestamp) {
        return CalendarDaySate.ACTIVE;
      }
      return CalendarDaySate.AVAILABLE;
    };
    t2 = getDayState();
    $[1] = day.isActiveMonth;
    $[2] = day.startTimestamp;
    $[3] = maxTimestamp;
    $[4] = minTimestamp;
    $[5] = selectedTimestamp;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const dayState = t2;
  const canSelect = dayState === CalendarDaySate.AVAILABLE;
  let t3;
  if ($[7] !== day.startTimestamp || $[8] !== minTimestamp || $[9] !== setSelectedTimestamp) {
    t3 = () => {
      if (minTimestamp && day.startTimestamp <= minTimestamp && day.startTimestamp + Time.days(1).toMillis() > minTimestamp) {
        setSelectedTimestamp(minTimestamp);
      } else {
        setSelectedTimestamp(day.startTimestamp);
      }
    };
    $[7] = day.startTimestamp;
    $[8] = minTimestamp;
    $[9] = setSelectedTimestamp;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleClick = t3;
  const t4 = !canSelect;
  const t5 = `${BUTTON_CLASSES[dayState]} tw-mx-auto tw-relative tw-border tw-border-transparent tw-border-solid tw-h-9 tw-w-9 sm:tw-h-8 sm:tw-w-8 tw-rounded-lg tw-transition tw-duration-300 tw-ease-out focus:tw-z-10`;
  let t6;
  if ($[11] !== day.date) {
    t6 = <span className="tw-text-sm tw-mx-auto tw-flex tw-items-center tw-justify-center tw-rounded-full">{day.date}</span>;
    $[11] = day.date;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== handleClick || $[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = <button type="button" onClick={handleClick} disabled={t4} className={t5}>{t6}</button>;
    $[13] = handleClick;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}